import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { exitDuperbrowse } from '../../../Duperbrowse/redux/actionCreators';
import { getCurrentItem } from '../../../Duperbrowse/redux/selectors';
import { Props } from './BackButton';

export type StateProps = Pick<Props, 'currentDuperbrowseItem'>;
export type DispatchProps = Pick<Props, 'exitDuperbrowse'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  currentDuperbrowseItem: getCurrentItem(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  exitDuperbrowse,
};

export default connect(mapStateToProps, mapDispatchToProps);
